import React from "react"
import { useTranslation } from "react-i18next"

const SelectField = ({ options, onChange, field, form, inputProps }) => {
  const { t } = useTranslation()

  return (
    <select
      name={field.name}
      value={field.value || ""}
      style={{
        padding: "8px 12px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        fontSize: "16px",
        cursor: "pointer",
        minWidth: "200px",
        backgroundColor: "#fff",
      }}
      onChange={e => {
        const newValue = e.target.value || null
        form?.setFieldValue(field.name, newValue)
        if (onChange) {
          onChange(newValue)
        }
      }}
    >
      <option value="">{t("select.placeholder")}</option>
      {options?.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export { SelectField as Select }